import { Component, OnInit } from '@angular/core';
import { MasterHelpService } from '../../services/masterhelp.service';
import { MasterHelpModel } from '../../models/MasterHelp.model';
import { MessageService,ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { LanguageConstants } from 'src/app/shared-components/constant';
@Component({
  standalone: false,
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit {
  files: MasterHelpModel[] = [];
  HelpMenuselectall = false;
  SelectedID:number;
  Status:boolean;
  UpdatedData;
  currDiv: string = 'introdba';
  private classToScrollTo: string = null;
  langCode: string;
  currLangTranslation: any;

  constructor(private masterHelpService: MasterHelpService, private messageService: MessageService, route: ActivatedRoute,
    private router: Router, private translateService: TranslateService) { }

  private getAllmasterHelp(): void {
  this.masterHelpService.getAllMasterHelp().subscribe((data: MasterHelpModel[]) => {
    this.files = data;
    });}
    private updateHelp():void {
      const selectedid=this.SelectedID;
 
      this.masterHelpService.UpdatedHelp(selectedid, this.Status).subscribe((updatedData)=> {

        this.UpdatedData=updatedData;
      });
    }

    HelpMenuSelectAll() {

      const selected = this.HelpMenuselectall;

      this.files.filter((r)=> {
        r.DisplayContent = selected;
      });
    }

    HelpMenuSelectionSelect(helpRow) {
      if(helpRow !==undefined && helpRow!=null) {
      this.SelectedID=helpRow.StepId;
      this.Status=helpRow.DisplayContent;
      this.updateHelp();
    }
    }

  OnClose() {
    const referrer = document.referrer;
    const allowedOrigin = window.location.origin;

    if(referrer.startsWith(allowedOrigin)){
      //this._location.back();
    }
    else {
      this.router.navigate(['/home']);
    }
  }


 
   scrollToElement(divVal: string)   {
    this.currDiv = divVal;
    this.scrollToFirst(this.currDiv);
   }
 
   ngAfterViewChecked(){
    this.doScroll();
}

  scrollToFirst(className: string) {
    this.classToScrollTo = className;
  }

  doScroll() {
    if (!this.classToScrollTo) {
      return;
    }
    try {
      var elements = document.getElementsByClassName(this.classToScrollTo);
      if (elements.length == 0) {
        return;
      }
      elements[0].scrollIntoView();
    }
    finally {
      this.classToScrollTo = null;
    }
  }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    let rowid;
    this.getAllmasterHelp();
    this.HelpMenuSelectionSelect(rowid);
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
      this.langCode = langEvent.lang;
    });    
  }
}
